import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {};

const PostDetailModalFooterSkeleton: FC<Props> = (props) => {
  return (
    <div className="tw-flex tw-justify-end tw-bg-grayscale-30 tw-px-6 tw-py-3">
      <div className="tw-w-2/5">
        <Skeleton height={36} width="100%" />
      </div>
    </div>
  );
};

export default PostDetailModalFooterSkeleton;
